module.exports = __webpack_public_path__ + "img/payrangers3.3cdfb089.png";